var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _isEqual from "lodash/isEqual";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.promise.all-settled.js";
import { globalHistory } from "@reach/router";
import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { navigate } from "gatsby-link";
import moment from "moment";
import { saveAddrInfo, saveEduInfo, saveFinInfo, saveOcpInfo, saveQuoteInfo, saveTaxInfo, saveOcrInfo, paymentConfirm, saveTFQuoteInfo, saveTLQuoteInfo, save3In1QuoteInfo, saveMicroSavingsQuoteInfo, saveCi1QuoteInfo, savePa1QuoteInfo, saveOtcQuoteInfo, saveSt1QuoteInfo, saveD1QuoteInfo, saveD2QuoteInfo, saveD2LQuoteInfo, saveM1QuoteInfo // saveM2QuoteInfo,
 } from "../qnb/api/quotationSave"; // import { CmsJourneyContext } from "../qnb/components/cmsJourney";
import { addressPageReverseMapper, educationPageReverseMapper, ekycApplInput2PageReverseMapper, employmentStatusPageReverseMapper, employmentStatusPartyPageReverseMapper, incomePageReverseMapper, insurancePageReverseMapper, jobPageReverseMapper, planSelectPageReverseMapper, saveAddrInfoMapper, saveEduInfoMapper, saveFinInfo1Mapper, savePremiumInfo1Mapper, saveFinInfo2Mapper, saveOcpInfo1Mapper, saveOcpInfo2Mapper, saveOcrInfoMapper, saveQuoteInfoMapper, saveTaxInfoMapper, sourcesOfFundsPageReverseMapper, taxPageReverseMapper, nonCreditCardPaymentConfirmChequeMapper, nonCreditCardPaymentConfirmBankMapper, nonCreditCardPaymentConfirmHsbcMapper, contactPageReverseMapper, saveTF1QuoteInfoMapper, planSelectTF1PageReverseMapper, saveTLQuoteInfoMapper, planSelectTLPageReverseMapper, nonCreditCardPaymentConfirmFpsMapper, planSelectTL2PageReverseMapper, saveTL2QuoteInfoMapper, planSelectTL3PageReverseMapper, saveTL3QuoteInfoMapper, planSelectE1PageReverseMapper, save3in1QuoteInfoMapper, planSelect3in1PageReverseMapper, saveCi1QuoteInfoMapper, planSelectCi1PageReverseMapper, savePa1QuoteInfoMapper, planSelectPa1PageReverseMapper, planSelectMicroSavingsPageReverseMapper, saveMicroSavingsQuoteInfoMapper, planSelectOtcPageReverseMapper, planSelectM1PageReverseMapper, // planSelectM2PageReverseMapper,
saveOtcQuoteInfoMapper, saveM1QuoteInfoMapper, // saveM2QuoteInfoMapper,
saveOcpInfo1PartyMapper, saveOcpInfo2PartyMapper, jobPartyPageReverseMapper, saveAddrInfoPartyMapper, addressPartyPageReverseMapper, ekycPartyInput2PageReverseMapper, savePartyOcrInfoMapper, planSelectSt1PageReverseMapper, saveSt1QuoteInfoMapper, planSelectD1PageReverseMapper, saveD1QuoteInfoMapper, saveD2QuoteInfoMapper, saveD2LQuoteInfoMapper, planSelectD2PageReverseMapper, planSelectD2LPageReverseMapper } from "../qnb/data-mapper/s3/s3DataMapper";
import { prefillValidation } from "../qnb/store-utils";
import { pushDataLayer } from "../shared/context/gtm-manager";
import { fetchPlanPremium, loadPage } from "./qnbProductSlice";
var initialState = { qnbLastCall: 0, currentPageId: null, completedPageIds: [], planSelectType: "plan_select", quotationNumber: "", formState: {}, nextStep: null, pageNavigating: false, lastNavigated: null, defaultDiscountCode: null, defaultPlanFlag: null, toastText: null, discountCodes: {}, promoCodeList: { discountCode1: undefined, discountCode2: undefined, discountCode3: undefined } };
var discountCodesSessionKey = function discountCodesSessionKey(quoteNo) { return "qnb_discount_codes_" + quoteNo; };
var parseStoredDiscountCodes = function parseStoredDiscountCodes(raw) {
    var parsed = JSON.parse(raw);
    var result = {};
    Object.entries(parsed).forEach(function (_ref) {
        var planLevel = _ref[0], value = _ref[1];
        if (typeof value === "string") { // 兼容旧格式：空串视为未提交（删码后同页刷新应恢复 CMS）
            result[planLevel] = { code: value, committed: value !== "" };
            return;
        }
        if (value && typeof value === "object" && "code" in value && typeof value.code === "string") {
            var entry = value;
            result[planLevel] = { code: entry.code, committed: Boolean(entry.committed) };
        }
    });
    return result;
};
var loadStoredDiscountCodes = function loadStoredDiscountCodes(quoteNo) { if (!quoteNo || typeof sessionStorage === "undefined")
    return {}; try {
    var raw = sessionStorage.getItem(discountCodesSessionKey(quoteNo));
    return raw ? parseStoredDiscountCodes(raw) : {};
}
catch (_unused) {
    return {};
} };
var loadCommittedDiscountCodes = function loadCommittedDiscountCodes(quoteNo) { var stored = loadStoredDiscountCodes(quoteNo); return Object.fromEntries(Object.entries(stored).filter(function (_ref2) { var entry = _ref2[1]; return entry.committed; }).map(function (_ref3) { var planLevel = _ref3[0], entry = _ref3[1]; return [planLevel, entry.code]; })); };
var persistCommittedPlanPromo = function persistCommittedPlanPromo(quoteNo, planLevel, discountCode) {
    if (!quoteNo || typeof sessionStorage === "undefined")
        return;
    try {
        var stored = loadStoredDiscountCodes(quoteNo);
        stored[planLevel] = { code: discountCode, committed: true };
        sessionStorage.setItem(discountCodesSessionKey(quoteNo), JSON.stringify(stored));
    }
    catch (_unused2) { // noop
    }
};
var clearDiscountCodesSession = function clearDiscountCodesSession(quoteNo) {
    if (!quoteNo || typeof sessionStorage === "undefined")
        return;
    try {
        sessionStorage.removeItem(discountCodesSessionKey(quoteNo));
    }
    catch (_unused3) { // noop
    }
};
var pageSubmit = { plan_select: { mapper: saveQuoteInfoMapper, submit: saveQuoteInfo, reverseMapper: planSelectPageReverseMapper }, plan_select_e1: { mapper: saveQuoteInfoMapper, submit: saveQuoteInfo, reverseMapper: planSelectE1PageReverseMapper }, plan_select_st1: { mapper: saveSt1QuoteInfoMapper, submit: saveSt1QuoteInfo, reverseMapper: planSelectSt1PageReverseMapper }, plan_select_tf1: { mapper: saveTF1QuoteInfoMapper, submit: saveTFQuoteInfo, reverseMapper: planSelectTF1PageReverseMapper }, plan_select_tl: { mapper: saveTLQuoteInfoMapper, submit: saveTLQuoteInfo, reverseMapper: planSelectTLPageReverseMapper }, plan_select_tl2: { mapper: saveTL2QuoteInfoMapper, submit: saveTLQuoteInfo, reverseMapper: planSelectTL2PageReverseMapper }, plan_select_tl3: { mapper: saveTL3QuoteInfoMapper, submit: saveTLQuoteInfo, reverseMapper: planSelectTL3PageReverseMapper }, plan_select_3in1: { mapper: save3in1QuoteInfoMapper, submit: save3In1QuoteInfo, reverseMapper: planSelect3in1PageReverseMapper }, plan_select_micro_savings: { mapper: saveMicroSavingsQuoteInfoMapper, submit: saveMicroSavingsQuoteInfo, reverseMapper: planSelectMicroSavingsPageReverseMapper }, plan_select_ci1: { mapper: saveCi1QuoteInfoMapper, submit: saveCi1QuoteInfo, reverseMapper: planSelectCi1PageReverseMapper }, plan_select_ropci: { mapper: save3in1QuoteInfoMapper, submit: save3In1QuoteInfo, reverseMapper: planSelect3in1PageReverseMapper }, plan_select_pa1: { mapper: savePa1QuoteInfoMapper, submit: savePa1QuoteInfo, reverseMapper: planSelectPa1PageReverseMapper }, plan_select_otc: { mapper: saveOtcQuoteInfoMapper, submit: saveOtcQuoteInfo, reverseMapper: planSelectOtcPageReverseMapper }, plan_select_d1: { mapper: saveD1QuoteInfoMapper, submit: saveD1QuoteInfo, reverseMapper: planSelectD1PageReverseMapper }, plan_select_d2: { mapper: saveD2QuoteInfoMapper, submit: saveD2QuoteInfo, reverseMapper: planSelectD2PageReverseMapper }, plan_select_d2l: { mapper: saveD2LQuoteInfoMapper, submit: saveD2LQuoteInfo, reverseMapper: planSelectD2LPageReverseMapper }, plan_select_m1: { mapper: saveM1QuoteInfoMapper,
        submit: saveM1QuoteInfo,
        reverseMapper: planSelectM1PageReverseMapper //初始化數據回顯
    },
    //   mapper: saveM2QuoteInfoMapper,
    //   submit: saveM2QuoteInfo,
    //   reverseMapper: planSelectM2PageReverseMapper,
    // },
    employment_status: { mapper: saveOcpInfo1Mapper, submit: saveOcpInfo, reverseMapper: employmentStatusPageReverseMapper }, employment_status_party: { mapper: saveOcpInfo1PartyMapper, submit: saveOcpInfo, reverseMapper: employmentStatusPartyPageReverseMapper }, job: { mapper: saveOcpInfo2Mapper, submit: saveOcpInfo, reverseMapper: jobPageReverseMapper }, job_party: { mapper: saveOcpInfo2PartyMapper, submit: saveOcpInfo, reverseMapper: jobPartyPageReverseMapper }, education: { mapper: saveEduInfoMapper, submit: saveEduInfo, reverseMapper: educationPageReverseMapper }, income: { mapper: saveFinInfo1Mapper, submit: saveFinInfo, reverseMapper: incomePageReverseMapper }, insurance: { mapper: savePremiumInfo1Mapper, submit: saveFinInfo, reverseMapper: insurancePageReverseMapper }, sources_of_funds: { mapper: saveFinInfo2Mapper, submit: saveFinInfo, reverseMapper: sourcesOfFundsPageReverseMapper }, tax: { mapper: saveTaxInfoMapper, submit: saveTaxInfo, reverseMapper: taxPageReverseMapper }, address: { mapper: saveAddrInfoMapper, submit: saveAddrInfo, reverseMapper: addressPageReverseMapper }, address_party: { mapper: saveAddrInfoPartyMapper, submit: saveAddrInfo, reverseMapper: addressPartyPageReverseMapper }, contact: { mapper: function mapper() { }, submit: function () { var _submit = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() { return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                case "end": return _context.stop();
            }
        } }, _callee); })); function submit() { return _submit.apply(this, arguments); } return submit; }(), reverseMapper: contactPageReverseMapper }, ekyc_appl_input_2: { mapper: saveOcrInfoMapper, submit: saveOcrInfo, reverseMapper: ekycApplInput2PageReverseMapper }, ekyc_party_input_2: { mapper: savePartyOcrInfoMapper, submit: saveOcrInfo, reverseMapper: ekycPartyInput2PageReverseMapper }, payment_cheque: { mapper: nonCreditCardPaymentConfirmChequeMapper, submit: paymentConfirm }, payment_bank: { mapper: nonCreditCardPaymentConfirmBankMapper, submit: paymentConfirm }, payment_hsbc: { mapper: nonCreditCardPaymentConfirmHsbcMapper, submit: paymentConfirm }, payment_fps: { mapper: nonCreditCardPaymentConfirmFpsMapper, submit: paymentConfirm } };
export var submitForm = createAsyncThunk("qnb/submitForm", /*#__PURE__*/ function () { var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(payload, thunkApi) { var productConfig, qnbState, pages, summaryIndex, submitIndex, lastNavigatedIndex, equal, config, _state, _config$mapper, _config$submit, _req; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            productConfig = thunkApi.getState();
            qnbState = thunkApi.getState().qnb;
            pages = productConfig.qnbProduct.productConfig.normalizedPages;
            summaryIndex = pages.findIndex(function (p) { return p.pageId === "summary"; });
            submitIndex = pages.findIndex(function (p) { return p.pageId === payload.pageId; });
            lastNavigatedIndex = pages.findIndex(function (p) { return p.pageId === qnbState.lastNavigated; });
            if (submitIndex < summaryIndex && lastNavigatedIndex > summaryIndex) {
                thunkApi.dispatch(forceSetLastNavigated("summary"));
            }
            equal = _isEqual(payload.formState, thunkApi.getState().qnb.formState[payload.pageId]);
            config = pageSubmit[payload.pageId];
            if (!config) {
                _context2.next = 22;
                break;
            }
            _state = thunkApi.getState();
            _context2.prev = 11;
            _req = Object.assign({ quoteNo: _state.qnb.quotationNumber, useSubmitTime: true }, (_config$mapper = config.mapper) === null || _config$mapper === void 0 ? void 0 : _config$mapper.call(config, payload.formState, _state.qnb.formState, _state));
            if (_req.quoteNo === "discard") {
                delete _req.quoteNo;
            }
            _context2.next = 16;
            return (_config$submit = config.submit) === null || _config$submit === void 0 ? void 0 : _config$submit.call(config, _req, thunkApi.getState(), equal, payload.language);
        case 16:
            _context2.next = 22;
            break;
        case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](11);
            console.error("submitForm error::", _context2.t0);
            return _context2.abrupt("return", thunkApi.rejectWithValue(_context2.t0));
        case 22: return _context2.abrupt("return", Object.assign({}, payload));
        case 23:
        case "end": return _context2.stop();
    }
} }, _callee2, null, [[11, 18]]); })); return function (_x, _x2) { return _ref4.apply(this, arguments); }; }());
export var showToast = createAction("qnb/showToast");
export var hideToast = createAction("qnb/hideToast"); /** 继续报价：报价页（QQ1）不应被 init 自动 skip */
var PLAN_SELECT_PAGE_IDS = ["plan_select", "plan_select_e1", "plan_select_tf1", "plan_select_tl", "plan_select_tl2", "plan_select_tl3", "plan_select_3in1", "plan_select_micro_savings", "plan_select_ci1", "plan_select_ropci", "plan_select_pa1", "plan_select_otc", "plan_select_m1", "plan_select_m2", "plan_select_st1", "plan_select_d1", "plan_select_d2", "plan_select_d2l"];
var isPlanSelectPage = function isPlanSelectPage(pageId) { return PLAN_SELECT_PAGE_IDS.includes(pageId); };
var isContinueQuoteFlag = function isContinueQuoteFlag() { var _URLSearchParams$get; var flag = (_URLSearchParams$get = new URLSearchParams(globalHistory.location.search).get("flag")) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : ""; return flag === "continue"; };
export var goStepGuarded = createAsyncThunk("qnb/goStepGuarded", /*#__PURE__*/ function () { var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(payload, thunkApi) { var _state$qnb$lastNaviga; var state, pageIds, lastNavigated, targetPage; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
    switch (_context3.prev = _context3.next) {
        case 0:
            state = thunkApi.getState();
            if (!state.qnb.pageNavigating) {
                _context3.next = 3;
                break;
            }
            return _context3.abrupt("return", thunkApi.rejectWithValue("Page loading"));
        case 3:
            pageIds = state.qnbProduct.productConfig.pageIds;
            lastNavigated = pageIds.indexOf((_state$qnb$lastNaviga = state.qnb.lastNavigated) !== null && _state$qnb$lastNaviga !== void 0 ? _state$qnb$lastNaviga : "");
            targetPage = pageIds.indexOf(payload.pageId);
            if (!(lastNavigated == -1 || targetPage == -1 || targetPage > lastNavigated)) {
                _context3.next = 8;
                break;
            }
            return _context3.abrupt("return", thunkApi.rejectWithValue("Page Guarded"));
        case 8: thunkApi.dispatch(goStep(payload));
        case 9:
        case "end": return _context3.stop();
    }
} }, _callee3); })); return function (_x3, _x4) { return _ref5.apply(this, arguments); }; }());
export var goStep = createAsyncThunk("qnb/goStep", /*#__PURE__*/ function () { var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(payload, thunkApi) { var _payload$updateUrl, _state$qnb, _state$qnb2; var state, targetStep, nextStep, goStep, MAX_GO_STEP_LOOPS, goStepLoopCount, loadedPage, pageLoadEvent, pages, summaryIndex, eventResult, _page$noSkip, _page$allowBack, page, pageNoSkip, allowBack, normalizedPages, lastNavigatedIndex, currentIndex, prefill, _latest$qnbProduct$qu, _latest$qnbProduct$qu2, latest, payByPolicyNo, prevTarget, _prevTarget, query, parsedQuery, loginState, userId, userLoggedIn, productCode, defaultPromoCode, previousUrl; return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
    switch (_context4.prev = _context4.next) {
        case 0:
            state = thunkApi.getState();
            targetStep = payload.pageId;
            if (!(payload.fromAction != "override")) {
                _context4.next = 5;
                break;
            }
            if (!(targetStep === state.qnb.currentPageId)) {
                _context4.next = 5;
                break;
            }
            return _context4.abrupt("return", thunkApi.rejectWithValue("same page"));
        case 5:
            nextStep = state.qnb.nextStep;
            if (nextStep && (payload.fromAction === "pageSubmit" || payload.fromAction == "init") && !payload.overrideNext) {
                targetStep = nextStep;
            }
            goStep = false;
            MAX_GO_STEP_LOOPS = 40;
            goStepLoopCount = 0;
        case 10:
            goStepLoopCount += 1;
            if (!(goStepLoopCount > MAX_GO_STEP_LOOPS)) {
                _context4.next = 14;
                break;
            }
            goStep = true;
            return _context4.abrupt("break", 81);
        case 14:
            _context4.next = 16;
            return thunkApi.dispatch(loadPage(targetStep));
        case 16:
            loadedPage = _context4.sent;
            pageLoadEvent = loadedPage.payload.page.onPageLoad;
            pages = state.qnbProduct.productConfig.normalizedPages;
            summaryIndex = pages.findIndex(function (p) { return p.pageId === "summary"; });
            _context4.next = 22;
            return pageLoadEvent === null || pageLoadEvent === void 0 ? void 0 : pageLoadEvent(thunkApi, payload.fromAction);
        case 22:
            eventResult = _context4.sent;
            if (eventResult) {
                _context4.next = 57;
                break;
            }
            goStep = true;
            page = state.qnbProduct.productConfig.normalizedPages.find(function (p) { return p.pageId === targetStep; });
            pageNoSkip = (_page$noSkip = page === null || page === void 0 ? void 0 : page.noSkip) !== null && _page$noSkip !== void 0 ? _page$noSkip : false;
            allowBack = (_page$allowBack = page === null || page === void 0 ? void 0 : page.allowBack) !== null && _page$allowBack !== void 0 ? _page$allowBack : true;
            normalizedPages = state.qnbProduct.productConfig.normalizedPages;
            lastNavigatedIndex = normalizedPages.findIndex(function (i) { return i.pageId == state.qnb.lastNavigated; });
            currentIndex = normalizedPages.findIndex(function (i) { return i.pageId == state.qnb.currentPageId; });
            if (!((payload.fromAction === "pageSubmit" && currentIndex == lastNavigatedIndex || payload.fromAction === "init") && state.qnb.formState[targetStep] && !pageNoSkip)) {
                _context4.next = 46;
                break;
            }
            if (!(isContinueQuoteFlag() && isPlanSelectPage(targetStep))) {
                _context4.next = 34;
                break;
            }
            return _context4.abrupt("break", 81);
        case 34:
            _context4.next = 36;
            return prefillValidation(targetStep, thunkApi);
        case 36:
            prefill = _context4.sent;
            if (!prefill) {
                _context4.next = 43;
                break;
            }
            latest = thunkApi.getState();
            payByPolicyNo = (_latest$qnbProduct$qu = latest.qnbProduct.quoteInfo) === null || _latest$qnbProduct$qu === void 0 ? void 0 : (_latest$qnbProduct$qu2 = _latest$qnbProduct$qu.geQuoteMain) === null || _latest$qnbProduct$qu2 === void 0 ? void 0 : _latest$qnbProduct$qu2.payByPolicyNo;
            if (targetStep === "income" && !!payByPolicyNo) {
                eventResult = "income";
                goStep = true;
            }
            else {
                goStep = false;
                eventResult = "next";
            }
            _context4.next = 44;
            break;
        case 43: return _context4.abrupt("break", 81);
        case 44:
            _context4.next = 57;
            break;
        case 46:
            if (!((payload.fromAction === "backStep" || payload.fromAction === "progressBack") && lastNavigatedIndex === summaryIndex)) {
                _context4.next = 51;
                break;
            }
            goStep = true;
            eventResult = "ekyc_appl_input_2";
            _context4.next = 57;
            break;
        case 51:
            if (!((payload.fromAction === "backStep" || payload.fromAction === "progressBack") && !allowBack)) {
                _context4.next = 56;
                break;
            }
            goStep = false;
            eventResult = "next";
            _context4.next = 57;
            break;
        case 56: return _context4.abrupt("break", 81);
        case 57:
            if (!(payload.fromAction === "backStep" || payload.fromAction === "progressBack")) {
                _context4.next = 70;
                break;
            }
            prevTarget = targetStep;
            if (!(eventResult == "next")) {
                _context4.next = 65;
                break;
            }
            _context4.next = 62;
            return thunkApi.dispatch(findBackStep(targetStep));
        case 62:
            _context4.t0 = _context4.sent.payload;
            _context4.next = 66;
            break;
        case 65: _context4.t0 = eventResult;
        case 66:
            targetStep = _context4.t0;
            if (eventResult != null && eventResult !== "next" && targetStep === prevTarget) {
                goStep = true;
            }
            _context4.next = 80;
            break;
        case 70:
            _prevTarget = targetStep;
            if (!(eventResult == "next")) {
                _context4.next = 77;
                break;
            }
            _context4.next = 74;
            return thunkApi.dispatch(findNextStep(targetStep));
        case 74:
            _context4.t1 = _context4.sent.payload;
            _context4.next = 78;
            break;
        case 77: _context4.t1 = eventResult;
        case 78:
            targetStep = _context4.t1;
            if (eventResult != null && eventResult !== "next" && targetStep === _prevTarget) {
                goStep = true;
            }
        case 80: if (!goStep) {
            _context4.next = 10;
            break;
        }
        case 81:
            if ((_payload$updateUrl = payload.updateUrl) !== null && _payload$updateUrl !== void 0 ? _payload$updateUrl : true) {
                query = globalHistory.location.search;
                parsedQuery = new URLSearchParams(query);
                parsedQuery.set("step", targetStep);
                setTimeout(function () { var _payload$replace; var userKey = localStorage.getItem("customerIDHit"); if (userKey !== null && !userLoggedIn) {
                    localStorage.removeItem("customerIDHit");
                } navigate("?" + parsedQuery.toString(), { replace: (_payload$replace = payload.replace) !== null && _payload$replace !== void 0 ? _payload$replace : false }); });
            }
            thunkApi.dispatch(setLastNavigated(targetStep));
            loginState = state.qnbProduct.loginState;
            userId = loginState.userId;
            userLoggedIn = loginState.userLoggedIn;
            productCode = state.qnbProduct.quoteInfo.geQuoteMain.eid;
            defaultPromoCode = (state === null || state === void 0 ? void 0 : (_state$qnb = state.qnb) === null || _state$qnb === void 0 ? void 0 : _state$qnb.defaultDiscountCode) !== "" ? state === null || state === void 0 ? void 0 : (_state$qnb2 = state.qnb) === null || _state$qnb2 === void 0 ? void 0 : _state$qnb2.defaultDiscountCode : undefined;
            previousUrl = window.location.href;
            setTimeout(function () { if (targetStep == "payment") {
                previousUrl = localStorage.getItem("tncUrl");
            } pushDataLayer({ event: "trackVirtualPageView", page_location: window.location.href, page_title: document.title ? document.title : localStorage.getItem("qnbMetaTitle"), page_referrer: previousUrl.includes("step=") ? previousUrl : previousUrl.split("/apply")[0], customerIDHit: userId !== null && userId !== void 0 ? userId : "", loginStatus: userLoggedIn ? "logged in user" : "non-logged in user", qnb_step: targetStep, content_group: "qnb", blog_category: undefined, author: undefined }); });
            return _context4.abrupt("return", { pageId: targetStep, nextStep: payload.overrideNext ? nextStep : payload.nextStep });
        case 91:
        case "end": return _context4.stop();
    }
} }, _callee4); })); return function (_x5, _x6) { return _ref6.apply(this, arguments); }; }());
export var findBackStep = createAsyncThunk("qnb/findBackStep", /*#__PURE__*/ function () { var _ref7 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(payload, thunkApi) { var state, pageList, currentPageIndex, previousPage; return _regeneratorRuntime.wrap(function _callee5$(_context5) { while (1) {
    switch (_context5.prev = _context5.next) {
        case 0:
            state = thunkApi.getState();
            pageList = state.qnbProduct.productConfig.pageIds;
            currentPageIndex = pageList.indexOf(payload);
            if (!(currentPageIndex === -1 || currentPageIndex === 0)) {
                _context5.next = 5;
                break;
            }
            return _context5.abrupt("return", null);
        case 5:
            previousPage = pageList[currentPageIndex - 1];
            return _context5.abrupt("return", previousPage);
        case 7:
        case "end": return _context5.stop();
    }
} }, _callee5); })); return function (_x7, _x8) { return _ref7.apply(this, arguments); }; }());
export var backStep = createAsyncThunk("qnb/backStep", /*#__PURE__*/ function () { var _ref8 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(payload, thunkApi) { var _payload$fromAction; var state, currentPage, previousPage; return _regeneratorRuntime.wrap(function _callee6$(_context6) { while (1) {
    switch (_context6.prev = _context6.next) {
        case 0:
            state = thunkApi.getState();
            currentPage = state.qnb.currentPageId;
            _context6.next = 4;
            return thunkApi.dispatch(findBackStep(currentPage));
        case 4:
            previousPage = _context6.sent.payload;
            _context6.next = 7;
            return thunkApi.dispatch(goStep({ overrideNext: payload === null || payload === void 0 ? void 0 : payload.overrideNext, pageId: previousPage, updateUrl: true, replace: true, fromAction: (_payload$fromAction = payload === null || payload === void 0 ? void 0 : payload.fromAction) !== null && _payload$fromAction !== void 0 ? _payload$fromAction : "backStep" }));
        case 7: return _context6.abrupt("return", _context6.sent.payload.pageId);
        case 8:
        case "end": return _context6.stop();
    }
} }, _callee6); })); return function (_x9, _x10) { return _ref8.apply(this, arguments); }; }());
export var findNextStep = createAsyncThunk("qnb/findNextStep", /*#__PURE__*/ function () { var _ref9 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(payload, thunkApi) { var state, pageList, currentPageIndex, nextPage; return _regeneratorRuntime.wrap(function _callee7$(_context7) { while (1) {
    switch (_context7.prev = _context7.next) {
        case 0:
            state = thunkApi.getState();
            pageList = state.qnbProduct.productConfig.pageIds;
            currentPageIndex = pageList.indexOf(payload);
            if (!(currentPageIndex === -1 || currentPageIndex === pageList.length - 1)) {
                _context7.next = 5;
                break;
            }
            return _context7.abrupt("return", null);
        case 5:
            nextPage = pageList[currentPageIndex + 1];
            return _context7.abrupt("return", nextPage);
        case 7:
        case "end": return _context7.stop();
    }
} }, _callee7); })); return function (_x11, _x12) { return _ref9.apply(this, arguments); }; }());
export var nextStep = createAsyncThunk("qnb/nextStep", /*#__PURE__*/ function () { var _ref10 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee8(payload, thunkApi) { var _payload$fromAction2; var fromAction, state, currentPage, nextPage; return _regeneratorRuntime.wrap(function _callee8$(_context8) { while (1) {
    switch (_context8.prev = _context8.next) {
        case 0:
            fromAction = (_payload$fromAction2 = payload === null || payload === void 0 ? void 0 : payload.fromAction) !== null && _payload$fromAction2 !== void 0 ? _payload$fromAction2 : "nextStep";
            state = thunkApi.getState();
            currentPage = state.qnb.currentPageId;
            _context8.next = 5;
            return thunkApi.dispatch(findNextStep(currentPage));
        case 5:
            nextPage = _context8.sent.payload;
            _context8.next = 8;
            return thunkApi.dispatch(goStep({ pageId: nextPage, updateUrl: true, fromAction: fromAction, overrideNext: payload === null || payload === void 0 ? void 0 : payload.overrideNext }));
        case 8: return _context8.abrupt("return", _context8.sent.payload.pageId);
        case 9:
        case "end": return _context8.stop();
    }
} }, _callee8); })); return function (_x13, _x14) { return _ref10.apply(this, arguments); }; }());
export var setPageComplete = createAction("qnb/setPageComplete");
export var removePageComplete = createAction("qnb/removePageComplete");
export var setQuotationNumber = createAction("qnb/setQuotationNumber");
export var setDiscountCode = createAction("qnb/setDiscountCode");
export var setDefaultPlanFlag = createAction("qnb/setDefaultPlanFlag");
export var setPromoCodeList = createAction("qnb/setPromoCodeList");
export var resetStore = createAction("qnb/resetStore");
export var resetNextStep = createAction("qnb/resetNextStep");
export var removeJobState = createAction("qnb/removeJobState");
export var removeJobPartyState = createAction("qnb/removeJobPartyState");
export var prefillFormFromQuoteInfo = createAsyncThunk("qnb/prefillFormFromQuoteInfo", /*#__PURE__*/ function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee9(payload, thunkApi) {
        var _pageSubmit$payload;
        var quoteInfo, mapper, _state2, existingForm, mappedForm, blockSkipOnContinue;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        quoteInfo = thunkApi.getState().qnbProduct.quoteInfo;
                        mapper = (_pageSubmit$payload = pageSubmit[payload]) === null || _pageSubmit$payload === void 0 ? void 0 : _pageSubmit$payload.reverseMapper;
                        if (!mapper) {
                            _context9.next = 25;
                            break;
                        }
                        _state2 = thunkApi.getState();
                        existingForm = _state2.qnb.formState[payload];
                        _context9.next = 7;
                        return mapper === null || mapper === void 0 ? void 0 : mapper(quoteInfo, _state2);
                    case 7:
                        mappedForm = _context9.sent;
                        blockSkipOnContinue = isContinueQuoteFlag() && isPlanSelectPage(payload);
                        if (!mappedForm) {
                            _context9.next = 22;
                            break;
                        } // 报价单 discountCode 为空时 reverseMapper 常返回 null，勿覆盖用户已保存的空优惠码
                        if ((existingForm === null || existingForm === void 0 ? void 0 : existingForm.promo_code) !== undefined && (existingForm === null || existingForm === void 0 ? void 0 : existingForm.promo_code) !== null && (mappedForm.promo_code === null || mappedForm.promo_code === undefined)) {
                            mappedForm.promo_code = existingForm.promo_code;
                        }
                        if (!blockSkipOnContinue) {
                            _context9.next = 18;
                            break;
                        }
                        _context9.next = 14;
                        return thunkApi.dispatch(setPageComplete(payload));
                    case 14:
                        _context9.next = 16;
                        return thunkApi.dispatch(removePageComplete(payload));
                    case 16:
                        _context9.next = 20;
                        break;
                    case 18:
                        _context9.next = 20;
                        return thunkApi.dispatch(setPageComplete(payload));
                    case 20:
                        _context9.next = 24;
                        break;
                    case 22:
                        _context9.next = 24;
                        return thunkApi.dispatch(removePageComplete(payload));
                    case 24: return _context9.abrupt("return", { pageId: payload, formState: mappedForm });
                    case 25: return _context9.abrupt("return", thunkApi.rejectWithValue(null));
                    case 26:
                    case "end": return _context9.stop();
                }
            }
        }, _callee9);
    }));
    return function (_x15, _x16) { return _ref11.apply(this, arguments); };
}());
export var prefillAllPages = createAsyncThunk("qnb/prefillAllPages", /*#__PURE__*/ function () { var _ref12 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee10(payload, thunkApi) { var serverState, pageIds, requests; return _regeneratorRuntime.wrap(function _callee10$(_context10) { while (1) {
    switch (_context10.prev = _context10.next) {
        case 0:
            serverState = thunkApi.getState().qnbProduct;
            pageIds = serverState.productConfig.pageIds;
            requests = pageIds.map(function (page) { return thunkApi.dispatch(prefillFormFromQuoteInfo(page)); });
            _context10.next = 5;
            return Promise.allSettled(requests);
        case 5:
        case "end": return _context10.stop();
    }
} }, _callee10); })); return function (_x17, _x18) { return _ref12.apply(this, arguments); }; }());
export var updateSessionTime = createAction("qnb/updateSessionTime");
export var forceSetSessionTime = createAction("qnb/forceSetSessionTime");
export var forceSetStep = createAction("qnb/forceSetStep");
export var forceSetLastNavigated = createAction("qnb/forceSetLastNavigated");
export var setLastNavigated = createAsyncThunk("qnb/setLastNavigated", /*#__PURE__*/ function () { var _ref13 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee11(payload, thunkApi) { var _qnbState$lastNavigat; var serverState, qnbState, pageIds, currentLastNavigated, targetLastNavigated; return _regeneratorRuntime.wrap(function _callee11$(_context11) { while (1) {
    switch (_context11.prev = _context11.next) {
        case 0:
            serverState = thunkApi.getState().qnbProduct;
            qnbState = thunkApi.getState().qnb;
            pageIds = serverState.productConfig.pageIds;
            currentLastNavigated = pageIds.indexOf((_qnbState$lastNavigat = qnbState.lastNavigated) !== null && _qnbState$lastNavigat !== void 0 ? _qnbState$lastNavigat : "");
            targetLastNavigated = pageIds.indexOf(payload);
            if (!(targetLastNavigated > currentLastNavigated)) {
                _context11.next = 7;
                break;
            }
            return _context11.abrupt("return", payload);
        case 7: return _context11.abrupt("return", qnbState.lastNavigated);
        case 8:
        case "end": return _context11.stop();
    }
} }, _callee11); })); return function (_x19, _x20) { return _ref13.apply(this, arguments); }; }());
export var setFormState = createAction("qnb/setFormState");
export var setDiscountCodes = createAction("qnb/setDiscountCodes");
export var resetDiscountCodes = createAction("qnb/resetDiscountCodes");
export var qnbSlice = createSlice({ name: "qnb", initialState: initialState, reducers: {}, extraReducers: function extraReducers(builder) {
        builder.addCase(prefillFormFromQuoteInfo.fulfilled, function (state, action) { var _Object$assign; state.formState = Object.assign({}, state.formState, (_Object$assign = {}, _Object$assign[action.payload.pageId] = action.payload.formState, _Object$assign)); });
        builder.addCase(prefillFormFromQuoteInfo.rejected, function (state, action) { if (action.error.message != "Rejected") {
            console.error("error on prefill:", action.meta, action.error);
        } });
        builder.addCase(setPageComplete, function (state, action) { if (["plan_select", "plan_select_e1", "plan_select_tf1", "plan_select_tl", "plan_select_tl2", "plan_select_tl3", "plan_select_3in1", "plan_select_micro_savings", "plan_select_ci1", "plan_select_ropci", "plan_select_pa1", "plan_select_otc", "plan_select_m1", "plan_select_m2", "plan_select_st1", "plan_select_d1", "plan_select_d2", "plan_select_d2l"].includes(action.payload)) {
            state.planSelectType = action.payload;
        } state.completedPageIds = __spreadArray(__spreadArray([], __read(state.completedPageIds), false), [action.payload], false); });
        builder.addCase(removePageComplete, function (state, action) { state.completedPageIds = state.completedPageIds.filter(function (p) { return p !== action.payload; }); });
        builder.addCase(setFormState, function (state, action) { if (["plan_select", "plan_select_e1", "plan_select_tf1", "plan_select_tl", "plan_select_tl2", "plan_select_tl3", "plan_select_3in1", "plan_select_micro_savings", "plan_select_ci1", "plan_select_ropci", "plan_select_pa1", "plan_select_otc", "plan_select_m1", "plan_select_m2", "plan_select_st1", "plan_select_d1", "plan_select_d2", "plan_select_d2l"].includes(action.payload.pageId.toString())) {
            state.planSelectType = action.payload.pageId.toString();
        } state.formState[action.payload.pageId] = action.payload.formState; });
        builder.addCase(setQuotationNumber, function (state, action) { state.quotationNumber = action.payload; var committed = loadCommittedDiscountCodes(action.payload); if (Object.keys(committed).length > 0) {
            state.discountCodes = Object.assign({}, state.discountCodes, committed);
        } });
        builder.addCase(setDiscountCode, function (state, action) { state.defaultDiscountCode = action.payload; });
        builder.addCase(setDefaultPlanFlag, function (state, action) { state.defaultPlanFlag = action.payload; });
        builder.addCase(setPromoCodeList, function (state, action) { state.promoCodeList = action.payload; });
        builder.addCase(updateSessionTime, function (state) { state.qnbLastCall = +moment(); });
        builder.addCase(forceSetSessionTime, function (state, action) { state.qnbLastCall = action.payload; });
        builder.addCase(forceSetStep, function (state, action) { state.currentPageId = action.payload; });
        builder.addCase(forceSetLastNavigated, function (state, action) { state.lastNavigated = action.payload; });
        builder.addCase(setLastNavigated.fulfilled, function (state, action) { if (action.payload != null)
            state.lastNavigated = action.payload; });
        builder.addCase(submitForm.pending, function () { });
        builder.addCase(submitForm.rejected, function (state, action) { console.warn(action, "api rejected"); });
        builder.addCase(submitForm.fulfilled, function (state, action) { state.formState[action.payload.pageId] = action.payload.formState; if (action.payload.pageId === "plan_select_st1") {
            var _action$payload$formS, _action$payload$formS2;
            var planFlag = String((_action$payload$formS = (_action$payload$formS2 = action.payload.formState) === null || _action$payload$formS2 === void 0 ? void 0 : _action$payload$formS2.plan_flag) !== null && _action$payload$formS !== void 0 ? _action$payload$formS : "");
            if (planFlag) {
                var _action$payload$formS3, _action$payload$formS4;
                var promoCode = (_action$payload$formS3 = (_action$payload$formS4 = action.payload.formState) === null || _action$payload$formS4 === void 0 ? void 0 : _action$payload$formS4.promo_code) !== null && _action$payload$formS3 !== void 0 ? _action$payload$formS3 : "";
                state.discountCodes[planFlag] = promoCode;
                if (state.quotationNumber) {
                    persistCommittedPlanPromo(state.quotationNumber, planFlag, promoCode);
                }
            }
        } });
        builder.addCase(goStep.pending, function (state) { state.pageNavigating = true; });
        builder.addCase(goStep.fulfilled, function (state, action) { state.pageNavigating = false; if (!action.meta.arg.overrideNext) {
            var _action$payload$nextS;
            state.nextStep = (_action$payload$nextS = action.payload.nextStep) !== null && _action$payload$nextS !== void 0 ? _action$payload$nextS : null;
        } state.currentPageId = action.payload.pageId; });
        builder.addCase(goStep.rejected, function (state, action) { state.pageNavigating = false; console.error("error on loadPage:", action.meta, action.payload, action.error); console.error(action.error.stack); });
        builder.addCase(nextStep.fulfilled, function (state, action) {
            if (action.payload) { // state.currentPageId = action.payload.pageId;
                state.nextStep = action.payload.nextStep;
            }
        });
        builder.addCase(resetStore, function (state) { Object.assign(state, initialState); });
        builder.addCase(showToast, function (state, action) { state.toastText = action.payload.text; });
        builder.addCase(hideToast, function (state) { state.toastText = null; });
        builder.addCase(resetNextStep, function (state) { state.nextStep = null; state.lastNavigated = state.currentPageId; }); //QBR-1527
        builder.addCase(removeJobState, function (state) { delete state.formState["job"]; });
        builder.addCase(removeJobPartyState, function (state) { delete state.formState["job_party"]; }); // builder.addCase(backStep.fulfilled, (state, action) => {
        //   if (action.payload) {
        //     state.currentPageId = action.payload.pageId;
        //   }
        // });
        builder.addCase(setDiscountCodes, function (state, action) { var payload = action.payload; state.discountCodes[payload.planLevel] = payload.discountCode; });
        builder.addCase(resetDiscountCodes, function (state) { if (state.quotationNumber) {
            clearDiscountCodesSession(state.quotationNumber);
        } state.discountCodes = {}; });
        builder.addCase(fetchPlanPremium.fulfilled, function (state, action) {
            var payload = action.payload;
            var productCode = payload.productCode, planFlag = payload.planFlag, discountCode = payload.discountCode; // OTC default plan is resolved in planSelectOtc from Contentful initialPlanFlag.
            if (productCode === "BBNMER00") {
                return;
            }
            if (productCode === "BBNMER20") {
                state.formState["plan_select_m2"] = Object.assign({}, state.formState["plan_select_m2"], { plan_flag: planFlag, promo_code: discountCode });
            }
        });
    } });
